import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IChangePassword } from '../interfaces/IChangePassword';
import { IConfirmEmail } from '../interfaces/IConfirmarEmail';
import { Injectable } from '@angular/core';
import { IUser } from '../interfaces/IUser';
import { Usuario } from '../models/usuario';
import { TokenService } from '../utils/token.service';
import { environment } from 'src/environments/environment';
import { BuscadorReportePedido } from '../models/buscadorReportePedido';
import { BuscadorReportePedidoDetallado } from '../models/buscadorReportePedidoDetallado';

@Injectable({
  providedIn: 'root'
})

export class ReportesService {

  private reportesServerUri: string;
  private apiUrl = environment.apiUrl;

  constructor(
    private httpCliente: HttpClient,
    private configService: ConfigService,
    private tokenService: TokenService
  ) {
    this.reportesServerUri = this.apiUrl + '/' + this.configService.ReporteURI;
  }

  private getHeaders() {
    const authToken = this.tokenService.getAuthToken();
    const authTokenBearer = this.tokenService.getAuthTokenBearer();

    return new HttpHeaders({
      'Authorization': `Bearer ${authTokenBearer}`,      
      'PortalO2G' : `${authToken}`
    });
  }
  
  cReporteExcelUsuarios() {
    return this.httpCliente.get(this.reportesServerUri + 'CReporteExcelUsuarios', { headers: this.getHeaders() });
  }
  cReporteExcelCuentas(userName: string, adm: boolean) {
    return this.httpCliente.get(this.reportesServerUri + 'CReporteExcelCuentas?userName=' + userName + "&adm=" + adm, { headers: this.getHeaders() });
  }


  cPedidos(buscador: BuscadorReportePedido) {
    return this.httpCliente.post(this.reportesServerUri + 'CPedidos', buscador, { headers: this.getHeaders() });
  }
  cPedidosDetallados(buscador: BuscadorReportePedidoDetallado) {
    return this.httpCliente.post(this.reportesServerUri + 'CPedidosDetallados', buscador, { headers: this.getHeaders() });
  }

  cReporteExcelDistribuidoresXCantidadDisponible(nroCliente: string){
    return this.httpCliente.get(this.reportesServerUri + 'CReporteExcelDistribuidoresXCantidadDisponible?nroCliente='+ nroCliente, { headers: this.getHeaders() });
  }

    cReporteExcelDistribuidoresXLotes(nroCliente: string, idPais: string, idCompania: string, idSalesOrg: string){
    return this.httpCliente.get(this.reportesServerUri + 'CReporteExcelDistribuidoresXLotes?nroCliente='
      + nroCliente +'&idPais=' + idPais + '&idCompania=' + idCompania + '&idSalesOrg=' + idSalesOrg , { headers: this.getHeaders() });
  }
}